module.exports = {
  schema: {
    name: '累進帶資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        unique: true,
        name: '累進帶代碼',
      },
      distance: {
        type: 'String',
        name: '累進帶距離',
      },
    },
  },
  index: {
    primary: {
      key: {
        distance: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'distance', width: 100 },
      ],
    },
    editor: {
      config: { titleMd: 2 },
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'distance' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/lensProgDists.js